import type { SVGProps } from "react";

export const MFAEmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18px"
    height="13px"
    viewBox="0 0 18 13"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>Email</title>
    <path
      fill="#757575"
      d="M16.2628414,12 L10.8734156,7.02514543 L9.00001192,8.66437368 L7.14722978,7.04330669 L1.73940597,12 L16.2628414,12 Z M17,11.3195459 L17,1.66438411 L11.6302843,6.36288531 L17,11.3195459 Z M1,11.3212148 L6.39004454,6.38081757 L1,1.66487005 L1,11.3212148 Z M16.2407039,1 L1.75874803,1 L8.99998808,7.33562632 L16.2407039,1 Z M1,0 L17,0 C17.5522847,0 18,0.44771525 18,1 L18,12 C18,12.5522847 17.5522847,13 17,13 L1,13 C0.44771525,13 0,12.5522847 0,12 L0,1 C-1.11022302e-16,0.44771525 0.44771525,0 1,0 Z"
      id="path-1"
    ></path>
  </svg>
);
